module.exports = __webpack_public_path__ + "img/rank-table-girl-3.051085b7.jpg";